module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.seen == 'list') ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "input-group  pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "34px",
      "margin-top": "12px"
    },
    attrs: {
      "type": "text",
      "name": "message",
      "placeholder": "Buscar ..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('a', {
    staticClass: "btn btn-app pull-right bg-red",
    on: {
      "click": function($event) {
        _vm.nuevo()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus "
  }), _vm._v(" Nuevo\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "nav-tabs-custom"
  }, [_c('ul', {
    staticClass: "nav nav-tabs pull-left"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#tab_1",
      "data-toggle": "tab",
      "aria-expanded": "true"
    }
  }, [_vm._v("Activo (" + _vm._s(_vm.filteredItems.length) + ")")])]), _vm._v(" "), _c('li', {}, [_c('a', {
    attrs: {
      "href": "#tab_2",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_vm._v("Archivo (" + _vm._s(_vm.filteredEliminados.length) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "tab_1"
    }
  }, [(_vm.filteredItems.length > 0) ? _c('paginate', {
    attrs: {
      "name": "filteredItems",
      "list": _vm.filteredItems,
      "per": 15
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Proyecto")]), _vm._v(" "), _c('th', [_vm._v("Cliente")]), _vm._v(" "), _c('th', [_vm._v("Producto")]), _vm._v(" "), _c('th', [_vm._v(" ")])]), _vm._v(" "), _vm._l((_vm.paginated('filteredItems')), function(item) {
    return _c('tr', {
      key: item._id
    }, [_c('td', [_vm._v(_vm._s(item.proyecto))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cliente))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.producto))]), _vm._v(" "), (typeof item.asset === 'undefined') ? _c('td', [_c('button', {
      staticClass: "btn btn-block btn-primary btn-sm btn-edit",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.cargar(item)
        }
      }
    }, [_vm._v("Editar")]), _vm._v(" "), _c('i', {
      staticClass: "fas fa-times-circle",
      on: {
        "click": function($event) {
          _vm.remove(item)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (typeof item.asset != 'undefined') ? _c('td', [_c('i', {
      staticClass: "fas fa-sync"
    }), _vm._v("  Pendiente\n    \t\t\t                    ")]) : _vm._e()])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('paginate-links', {
    staticClass: "pagination pull-right",
    attrs: {
      "for": "filteredItems",
      "async": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab_2"
    }
  }, [(_vm.filteredEliminados.length > 0) ? _c('paginate', {
    attrs: {
      "name": "filteredEliminados",
      "list": _vm.filteredEliminados,
      "per": 15
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Proyecto")]), _vm._v(" "), _c('th', [_vm._v("Cliente")]), _vm._v(" "), _c('th', [_vm._v("Producto")]), _vm._v(" "), _c('th', [_vm._v(" ")])]), _vm._v(" "), _vm._l((_vm.paginated('filteredEliminados')), function(eliminado) {
    return _c('tr', {
      key: eliminado.id
    }, [_c('td', [_vm._v(_vm._s(eliminado.proyecto))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(eliminado.cliente))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(eliminado.producto))]), _vm._v(" "), (_vm.onlineState) ? _c('td', [_c('button', {
      staticClass: "btn btn-block btn-primary btn-sm btn-edit",
      staticStyle: {
        "max-width": "84px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.desarchivar(eliminado)
        }
      }
    }, [_vm._v("Desarchivar")])]) : _vm._e()])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('paginate-links', {
    staticClass: "pagination pull-right",
    attrs: {
      "for": "filteredEliminados",
      "async": true
    }
  })], 1)])])])])]) : _vm._e(), _vm._v(" "), (_vm.seen == 'form') ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.seen == 'form') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('a', {
    staticClass: "btn btn-app pull-right bg-red",
    on: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times "
  }), _vm._v(" Cerrar\n                ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.proyecto),
      expression: "input.proyecto"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "proyecto"
    },
    domProps: {
      "value": (_vm.input.proyecto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.input, "proyecto", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('proyecto')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Cliente")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.cliente),
      expression: "input.cliente"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "cliente"
    },
    domProps: {
      "value": (_vm.input.cliente)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.input, "cliente", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('cliente')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Producto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.producto),
      expression: "input.producto"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "producto"
    },
    domProps: {
      "value": (_vm.input.producto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.input, "producto", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('producto')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Descripción Producto")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.descripcion_producto),
      expression: "input.descripcion_producto"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "descripcion_producto"
    },
    domProps: {
      "value": (_vm.input.descripcion_producto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.input, "descripcion_producto", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('descripcion_producto')))])]), _vm._v(" "), (_vm.savebtn) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.guardar()
      }
    }
  }, [_vm._v("Crear")]) : _vm._e(), _vm._v(" "), (_vm.updatebtn) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.editar(_vm.input._id)
      }
    }
  }, [_vm._v("Editar")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")])])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Nuevo Registro")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12fca336"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Producto.vue
// module id = 1044
// module chunks = 1